import { useEffect, useState } from "react";
import type { User, UsersPage } from "../types";
import { usersService } from "../services/users-service";

export const useFetchUsers = (): [User[]] => {
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchData() {
      try {
        const usersPage: UsersPage = await usersService.getUsers({ page: 0, pageSize: 100 }, abortController);
        setUsers(usersPage?.list);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return [users];
};
